import logo from './logo.svg';
import './App.css';
import {useState} from "react";
import Papa from "papaparse";

function App() {
  const [parsedData, setParsedData] = useState([]);

  //State to store table Column name
  const [tableRows, setTableRows] = useState([]);

  //State to store the values
  const [values, setValues] = useState([]);

  const changeHandler = (event) => {
    // Passing file data (event.target.files[0]) to parse using Papa.parse
    Papa.parse(event.target.files[0], {
      header: true,
      skipEmptyLines: true,
      complete: function (results) {
        const rowsArray = [];
        const valuesArray = [];

        // Iterating data to get column name and their values
        results.data.map((d) => {
          rowsArray.push(Object.keys(d));
          valuesArray.push(Object.values(d));
        });

        // Parsed Data Response in array format
        setParsedData(results.data);

        // Filtered Column Names
        setTableRows(rowsArray[0]);

        // Filtered Values
        setValues(valuesArray);
      },
    });
  };
  const link =window.location.href.split("?link=");
  const params = link[1];
  if (params && params !== "undefined") {
    const link = document.createElement("a");
    link.href = "goloca://" +params;
    document.body.appendChild(link);
    link.click();
    // setTimeout(function() {
    //   // Link to the App Store should go here -- only fires if deep link fails
    //   window.location = "https://goloca.de/goloca_die-app-fuer-dein-digitales-einkaufserlebnis-in-deiner-stadt#ngparw7e7c150a052c6b89e74253011113428";
    // }, 500);
    //http://localhost:3000/?link=offer/ZeZ6hygGTMSeCFjTINBFwWyUkkp2
    return <></>
  }
  return (
      <div className={"h-screen w-screen bg-neutral-900 flex flex-row justify-center items-center"}>
        <div className={"h-[500px] w-[500px] bg-neutral-800 rounded-lg flex flex-col justify-center  items-center"}>
          <h1 className={"text-white text-2xl font-bold mt-2"}>Konto löschen</h1>
          <p className={"text-white text-sm mt-2"}>Melden Sie sich an, um Ihr Konto zu löschen</p>
            <div className={"flex flex-row justify-center items-center mt-4"}>
              <input type="text" placeholder={"E-Mail"} className={"bg-neutral-700 rounded-lg p-2 w-[300px] text-white"}/>
            </div>
            <div className={"flex flex-row justify-center items-center mt-4"}>
                <input type="password" placeholder={"Passwort"} className={"bg-neutral-700 rounded-lg p-2 w-[300px] text-white"}/>
            </div>
          <button className={"bg-primary-500 rounded-lg p-2 w-[300px] text-white mt-4"}>Anmelden</button>
        </div>
      </div>
    // <div className="App">
    //   <header className="App-header">
    //     <img src={logo} className="App-logo" alt="logo" />
    //     <p>
    //       Edit <code>src/App.js</code> and save to reload.
    //     </p>
    //     <a
    //       className="App-link"
    //       href="https://reactjs.org"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Learn React
    //     </a>
    //   </header>
    // </div>
  );
}

export default App;
